// eslint-disable-next-line no-undef
jQuery(document).ready(($) => {
  /* IE popup
  ========================================================================== */

  function checkIfIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
      // eslint-disable-next-line no-alert
      alert(
        "For an optimal viewing experience, please choose a different browser."
      );
    }

    return false;
  }

  checkIfIE();

  /* Set VW VH without horizontal scrollbar
  ========================================================================== */

  function setVwVh() {
    const vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty("--vw", "".concat(vw, "px"));

    const vh = document.documentElement.clientHeight / 100;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
  }

  window.addEventListener("resize", () => {
    setVwVh();
  });

  setVwVh();

  /* Accordion
  ========================================================================== */

  $(".accordion").on("click", (e) => {
    const acc = e.currentTarget;

    if (!$(acc).hasClass("accordion--active")) {
      $(acc)
        .parents(".accordions")
        .first()
        .find(".accordion--active")
        .toggleClass("accordion--active")
        .next(".panel")
        .slideToggle();
    }

    $(acc).toggleClass("accordion--active").next(".panel").slideToggle();
  });

  /* AOS
  ========================================================================== */

  if ($(".aos").length) {
    const { AOS } = window;

    document.querySelectorAll(".aos").forEach((el) => {
      const classNames = el.className.split(/\s+/);

      if (
        classNames.includes("aos_disable_mobile") &&
        window.screen.width <= 600
      ) {
        return;
      }

      classNames.forEach((item) => {
        if (item.includes("aos_")) {
          const parts = item.split("_", 3);

          if (parts.length > 2) {
            el.setAttribute(
              `data-aos-${parts[1]}`,
              item.substring(`${parts[0]}_${parts[1]}`.length + 1)
            );
          } else {
            el.setAttribute("data-aos", parts[1]);
          }
        }
      });
    });

    setTimeout(() => {
      AOS.init({
        // Global settings:
        disable: false,
        startEvent: "DOMContentLoaded",
        initClassName: "aos-init",
        animatedClassName: "aos-animate",
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,
        offset: 120,
        delay: 0,
        duration: 700,
        easing: "ease",
        once: true,
        mirror: false,
        anchorPlacement: "top-bottom",
      });
    }, 100);
  }

  /* Odometer
  ========================================================================== */

  const { Odometer } = window;

  $(document).on("aos:in:stats-animated", ({ detail }) => {
    $(detail)
      .find(".stats-odometer")
      .each((i, el) => {
        const oldStats = $(el).text();

        new Odometer({
          el,
          value: 0,
          theme: "default",
        }).update(oldStats);
      });
  });

  /* Homepage slider
  ========================================================================== */

  if ($(".home-slider").length) {
    // eslint-disable-next-line no-unused-vars
    const { Swiper } = window;

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(".home-slider", {
      loop: true,
      speed: 1000,
      autoplay: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
  }

  /* Testimonials slider
  ========================================================================== */

  if ($(".testimonials").length) {
    // eslint-disable-next-line no-unused-vars
    const { Swiper } = window;

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(".testimonials-swiper", {
      loop: true,
      speed: 1000,
      autoplay: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
  }

  /* Overlay
  ========================================================================== */

  const addOverlay = (dest, positionClass = "loading__loader--top") => {
    $(dest)
      .addClass("loading")
      .prepend(`<span class="loading__loader ${positionClass}"></span>`);
  };

  const removeOverlay = (dest) => {
    $(dest).removeClass("loading");
    $(".loading__loader").remove();
  };

  /* Paged variable controller for pagination of Banks result
  ========================================================================== */

  const pagedController = (() => {
    let paged = 1;

    return {
      increment: () => {
        paged += 1;
        return paged;
      },
      reset: () => {
        paged = 1;
        return paged;
      },
      get: () => paged,
    };
  })();

  /* eslint-disable camelcase */

  /* Create banks filter form based on Form.io
  ========================================================================== */

  const { Formio, ajaxObj } = window;

  const createBanksFilterForm = () =>
    Formio.createForm(document.querySelector(".banks-found__filters"), {
      display: "form",
      components: [
        {
          label: "Which state do you live in?",
          widget: "choicesjs",
          tableView: true,
          data: {
            values: [
              {
                label: "New South Wales",
                value: "New South Wales",
              },
              {
                label: "Victoria",
                value: "Victoria",
              },
              {
                label: "Queensland",
                value: "Queensland",
              },
              {
                label: "South Australia",
                value: "South Australia",
              },
              {
                label: "Western Australia",
                value: "Western Australia",
              },
              {
                label: "Tasmania",
                value: "Tasmania",
              },
              {
                label: "Northern Territory",
                value: "Northern Territory",
              },
              {
                label: "Australian Capital Territory",
                value: "Australian Capital Territory",
              },
            ],
          },
          key: "state",
          type: "select",
          input: true,
        },
        {
          label: "What services are you looking for?",
          optionsLabelPosition: "right",
          tableView: false,
          values: [
            {
              label: "Savings account",
              value: "Savings account",
              shortcut: "",
            },
            {
              label: "Personal loan",
              value: "Personal loan",
              shortcut: "",
            },
            {
              label: "Term deposit",
              value: "Term deposit",
              shortcut: "",
            },
            {
              label: "Credit card",
              value: "Credit card",
              shortcut: "",
            },
            {
              label: "Home loan",
              value: "Home loan",
              shortcut: "",
            },
            {
              label: "Insurance",
              value: "Insurance",
              shortcut: "",
            },
          ],
          key: "services",
          type: "selectboxes",
          input: true,
          inputType: "checkbox",
        },
        {
          label: "Which contactless payments are important to you?",
          optionsLabelPosition: "right",
          tableView: false,
          values: [
            {
              label: "Apple Pay",
              value: "Apple Pay",
              shortcut: "",
            },
            {
              label: "Google Pay",
              value: "Google Pay",
              shortcut: "",
            },
            {
              label: "Samsung Pay",
              value: "Samsung Pay",
              shortcut: "",
            },
            {
              label: "Garmin Pay",
              value: "Garmin Pay",
              shortcut: "",
            },
            {
              label: "Fitbit Pay",
              value: "Fitbit Pay",
              shortcut: "",
            },
          ],
          key: "contactless_payments",
          type: "selectboxes",
          input: true,
          inputType: "checkbox",
        },
        {
          label: "What technology is important to you?",
          optionsLabelPosition: "right",
          tableView: false,
          values: [
            {
              label: "Instant payments (e.g. PayID)",
              value: "Instant payments",
              shortcut: "",
            },
            {
              label: "Mobile banking app (iOS or Android)",
              value: "Mobile banking app",
              shortcut: "",
            },
          ],
          key: "technology",
          type: "selectboxes",
          input: true,
          inputType: "checkbox",
        },
        {
          label: "How do you like to bank?",
          optionsLabelPosition: "right",
          tableView: false,

          values: [
            {
              label: "In a branch",
              value: "In a branch",
              shortcut: "",
            },
            {
              label: "Bank@Post",
              value: "Bank at post",
              shortcut: "",
            },
            {
              label: "Digital bank",
              value: "Digital bank",
              shortcut: "",
            },
          ],
          key: "bank_channels",
          type: "selectboxes",
          input: true,
          inputType: "checkbox",
        },
        {
          label:
            "Do you (or a member of your family) work in one of these professions?",
          optionsLabelPosition: "right",
          inline: false,
          tableView: false,
          values: [
            {
              label: "Defence",
              value: "Defence",
              shortcut: "",
            },
            {
              label: "Energy",
              value: "Energy",
              shortcut: "",
            },
            {
              label: "Education",
              value: "Education",
              shortcut: "",
            },
            {
              label: "Emergency services",
              value: "Emergency services",
              shortcut: "",
            },
            {
              label: "Police",
              value: "Police",
              shortcut: "",
            },
            {
              label: "Woolworths",
              value: "Woolworths",
              shortcut: "",
            },
            {
              label: "Government",
              value: "Government",
              shortcut: "",
            },
            {
              label: "None of the above",
              value: "None of the above",
              shortcut: "",
            },
          ],
          key: "professions_businesses",
          type: "radio",
          input: true,
        },
      ],
    });

  /* Banks filter ajax call
  ========================================================================== */

  const banksFilterAjax = (
    state,
    services,
    contactless_payments,
    technology,
    bank_channels,
    professions_businesses,
    paged
  ) => {
    const filterValues = {
      state,
      services: Object.keys(services).filter((key) => services[key]),
      contactless_payments: Object.keys(contactless_payments).filter(
        (key) => contactless_payments[key]
      ),
      technology: Object.keys(technology).filter((key) => technology[key]),
      bank_channels: Object.keys(bank_channels).filter(
        (key) => bank_channels[key]
      ),
      professions_businesses,
      paged,
    };

    return $.ajax({
      type: "post",
      dataType: "json",
      url: ajaxObj.ajax_url,
      data: {
        action: "filter_banks",
        filterValues,
        _ajax_nonce: ajaxObj.nonce,
      },
    });
  };

  /* Set up handler for the change event of banks filter value
  ========================================================================== */

  const handleBanksFilterChange = ({
    data: {
      state = "",
      services = {},
      contactless_payments = {},
      technology = {},
      bank_channels = {},
      professions_businesses = "",
    },
  }) => {
    const paged = pagedController.reset();

    banksFilterAjax(
      state,
      services,
      contactless_payments,
      technology,
      bank_channels,
      professions_businesses,
      paged
    )
      .done((response) => {
        $(".banks-found__list").empty().append(response);

        removeOverlay(".banks-found__banks-wrapper");
      })
      .fail((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  };

  const setupOnBanksFilterChange = (banksFilter) => {
    banksFilter.on("change", () => {
      addOverlay(".banks-found__banks-wrapper");
    });

    // eslint-disable-next-line no-undef
    banksFilter.on("change", _.debounce(handleBanksFilterChange, 1500));
  };

  /* View more handler for bank filter results
  ========================================================================== */

  const setupOnBanksResultViewMoreClick = (banksFilter) => {
    $(document).on("click", ".banks-found__view-more-btn", () => {
      pagedController.increment();

      const paged = pagedController.get();

      addOverlay(".banks-found__banks-wrapper", "loading__loader--bottom");

      const {
        state = "",
        services = {},
        contactless_payments = {},
        technology = {},
        bank_channels = {},
        professions_businesses = "",
        // eslint-disable-next-line no-underscore-dangle
      } = banksFilter._data;

      banksFilterAjax(
        state,
        services,
        contactless_payments,
        technology,
        bank_channels,
        professions_businesses,
        paged
      )
        .done((response) => {
          $(".banks-found__view-more").remove();
          $(".banks-found__list").append(response);

          removeOverlay(".banks-found__banks-wrapper");
        })
        .fail((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    });
  };

  /* Set up initate values for the Bank Filter form
  ========================================================================== */

  const setupBanksFilterInitiateValues = (banksFilter) => {
    const fields = [
      "state",
      "services",
      "contactless_payments",
      "technology",
      "bank_channels",
      "professions_businesses",
    ];

    fields.forEach((field) => {
      banksFilter
        .getComponent(field)
        .setValue($(".banks-found__filters").data(`initiated-${field}`));
    });
  };

  /* Initiate Find a Bank Alt filters
  ========================================================================== */

  const initiateBankFilters = async () => {
    const banksFilter = await createBanksFilterForm();

    setupOnBanksFilterChange(banksFilter);

    setupOnBanksResultViewMoreClick(banksFilter);

    setupBanksFilterInitiateValues(banksFilter);
  };

  // Initiate the filter on normal page
  if ($(".banks-found").length) {
    initiateBankFilters();
  }

  /* eslint-enable camelcase */

  /* Bank filters toggle
  ========================================================================== */

  $(".banks-found__sidebar-open").on("click", () => {
    $(".banks-found__sidebar").addClass("banks-found__sidebar--active");
    $("body").css("overflow-y", "hidden");
  });

  $(".banks-found__sidebar-close").on("click", () => {
    $(".banks-found__sidebar").removeClass("banks-found__sidebar--active");
    $("body").css("overflow-y", "");
  });

  /* Home form toggle
  ========================================================================== */

  $(".find-bank-form__btn--open-form").on("click", () => {
    $(".find-bank-form__form").slideDown(400, () => {
      window.scrollTo({
        top: $(".find-bank-form__form").offset().top,
        behavior: "smooth",
      });
    });
  });

  $(".find-bank-form__btn--close-form").on("click", () => {
    $(".find-bank-form__form").slideUp();
  });

  /* Board team bio toggle
  ========================================================================== */

  $(".board-team-member__info").on("click", (e) => {
    $(e.currentTarget).toggleClass("board-team-member__info--open");
    $(e.currentTarget).next(".board-team-member__bio").slideToggle();
  });

  /* Member logos
  ========================================================================== */

  const getRandomNonActiveMemberID = (activeMemberIDs, membersNum) => {
    let memberID = Math.floor(Math.random() * membersNum);

    while (activeMemberIDs.includes(memberID)) {
      memberID = Math.floor(Math.random() * membersNum);
    }

    return memberID;
  };

  const membersNum = $(".member-logos__item").length;
  const MAX_ACTIVE_MEMBERS_NUM = 10;

  if (membersNum > MAX_ACTIVE_MEMBERS_NUM) {
    const activeMemberIDs = Object.seal(
      Array(MAX_ACTIVE_MEMBERS_NUM).fill(null)
    );

    while (activeMemberIDs.includes(null)) {
      activeMemberIDs[activeMemberIDs.indexOf(null)] =
        getRandomNonActiveMemberID(activeMemberIDs, membersNum);
    }

    activeMemberIDs.forEach((activeMemberID, index) => {
      $(`.member-logos__item[data-item-id="${activeMemberID}"]`)
        .addClass(`member-logos__item--grid-${index}`)
        .fadeIn();
    });

    setInterval(() => {
      if (document.hasFocus()) {
        const memberIndex = Math.floor(Math.random() * MAX_ACTIVE_MEMBERS_NUM);
        const oldMemberID = activeMemberIDs[memberIndex];

        $(`.member-logos__item[data-item-id="${oldMemberID}"]`).fadeOut(
          400,
          () => {
            $(`.member-logos__item[data-item-id="${oldMemberID}"]`).removeClass(
              `member-logos__item--grid-${memberIndex} `
            );
          }
        );

        const newMemberID = getRandomNonActiveMemberID(
          activeMemberIDs,
          membersNum
        );
        activeMemberIDs[memberIndex] = newMemberID;

        $(`.member-logos__item[data-item-id="${newMemberID}"]`)
          .addClass(`member-logos__item--grid-${memberIndex}`)
          .fadeIn();
      }
    }, 1000);
  }

  /* Toggle social share links panel
  ========================================================================== */

  $(".social-share__share-button").on("click", () => {
    $(".social-share__share-links").slideToggle();
  });
  $(".social-share__close").on("click", () => {
    $(".social-share__share-links").slideUp();
  });

  /* Copy link
  ========================================================================== */

  $(".social-share__social-link--copy-link").on("click", () => {
    navigator.clipboard.writeText(window.location.href);
    // eslint-disable-next-line no-alert
    alert("Link copied!");
  });

  /* Our member nav
  ========================================================================== */

  if ($(".our-members__list").length) {
    $(".our-members__list")
      .clone()
      .removeClass("our-members__list")
      .addClass("our-members__list--full")
      .appendTo(".our-members");
  }

  $(".our-members__nav-button").on("click", (e) => {
    const target = e.currentTarget;
    const filter = $(target).parent().data("filter");
    const attrSelector =
      filter === "View all" ? "" : `[data-group="${filter}"]`;

    $(".our-members__nav-button--selected").removeClass(
      "our-members__nav-button--selected"
    );

    $(target).addClass("our-members__nav-button--selected");

    $(".our-members__list").fadeOut(400, () => {
      $(".our-members__list")
        .empty()
        .append(
          $(
            `.our-members__list--full > .our-members__item${attrSelector}`
          ).clone()
        );

      if ($(".our-members__list").children().length === 0) {
        $(".our-members__list").append("<p>Sorry, no matches were found.</p>");
      }

      $(".our-members__list").fadeIn();
    });
  });
});
